import { Button } from '@99designs/common/components/Button';
import { ButtonGroup, ButtonGroupItem } from '@99designs/common/components/ButtonGroup';
import { DesignerMeta_User } from '__generated__/DesignerMeta_User';
import Visible from 'common/components/Visible';
import { handlePromise } from 'common/utils/Bugsnag';
import { Color } from 'projects/consts';
import { trackRemovedDesignerEvent } from 'projects/events';
import RemoveStructuredBriefDesigners from 'projects/mutations/RemoveStructuredBriefDesigners';
import React from 'react';
import ColorComponent from './Color';
import ConfirmationModal from './ConfirmationModal';
import DesignerMeta from './DesignerMeta';

interface Props {
    brief: {
        id: string;
        designers: DesignerMeta_User[];
    };
    onConfirm: () => void;
    onDismiss: () => void;
    saving?: boolean;
    showing: boolean;
}

const DesignerConfirmationModal: React.SFC<Props> = ({
    brief,
    onConfirm,
    onDismiss,
    saving = false,
    showing,
}) => {
    return (
        <ConfirmationModal
            onDismiss={onDismiss}
            heading={__('Confirm your designers')}
            showing={showing}
        >
            <RemoveStructuredBriefDesigners>
                {removeDesigners => (
                    <div className="designer-meta-list">
                        {brief.designers.map(designer => (
                            <div className="designer-meta-list__item" key={designer.id}>
                                <DesignerMeta
                                    hasFullStats={false}
                                    designer={designer}
                                    onRemove={id => {
                                        trackRemovedDesignerEvent({
                                            id: brief.id,
                                            designer_id: designer.id,
                                        });
                                        handlePromise(
                                            removeDesigners({
                                                id: brief.id,
                                                designerIds: [id],
                                            }),
                                            'DesignerConfirmationModal RemoveDesigners'
                                        );
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </RemoveStructuredBriefDesigners>
            <div style={{ textAlign: 'right' }}>
                <ButtonGroup>
                    <ButtonGroupItem>
                        <a
                            type="button"
                            onClick={e => {
                                e.preventDefault();
                                return onDismiss();
                            }}
                            className="link link--back link--big-target"
                        >
                            {__('Back')}
                        </a>
                    </ButtonGroupItem>
                    <ButtonGroupItem>
                        <ColorComponent color={Color.createBlue}>
                            <Visible sizes={['small', 'medium']}>
                                <Button
                                    onClick={onConfirm}
                                    variations={['primary', 'chameleon']}
                                    isSaving={saving}
                                >
                                    {__('Request quotes')}
                                </Button>
                            </Visible>
                            <Visible sizes={['normal', 'large']}>
                                <Button
                                    onClick={onConfirm}
                                    variations={['primary', 'jumbo', 'chameleon']}
                                    isSaving={saving}
                                >
                                    {__('Request quotes')}
                                </Button>
                            </Visible>
                        </ColorComponent>
                    </ButtonGroupItem>
                </ButtonGroup>
            </div>
        </ConfirmationModal>
    );
};

export default DesignerConfirmationModal;
